import { EarningMechanism, OfferUpdateInput, OfferFragment } from '@occc/graphql';
import { Operation } from '@occc-app/offerHelpers/types';

import { supportedEarningMechanisms } from './constants';

export const isSupportedEarningMechanism = (earningMechanism: EarningMechanism['__typename']) => {
  return supportedEarningMechanisms.includes(earningMechanism);
};

export const createOperationToDisableTriggerOnProgress = (
  offerId: string,
  triggerPreferences: OfferFragment['triggerPreferences'],
) => {
  const input: OfferUpdateInput = {
    id: offerId,
    triggerPreferences: {
      triggerOnVisibility: triggerPreferences.triggerOnVisibility,
      triggerOnFulfillment: triggerPreferences.triggerOnFulfillment,
      triggerOnProgress: false,
    },
  };

  const operation: Operation = {
    name: 'offerUpdate',
    variables: {
      input,
    },
  };

  return operation;
};
